import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Non-blocking User Agent Guard
 * Renders children IMMEDIATELY and checks UA in background
 * Only redirects if explicitly blocked - never blocks page render
 */
const UserAgentGuard = ({ children }) => {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    // Skip check in TikTok/social in-app browsers to avoid blocking
    const ua = navigator.userAgent || '';
    const isInAppBrowser = /TikTok|Instagram|FBAN|FBAV|Twitter|Line|Snapchat/i.test(ua);
    
    // If in-app browser, skip the check entirely (never block ad traffic)
    if (isInAppBrowser) return;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3s max

    const checkUserAgent = async () => {
      try {
        const response = await axios.post(`${API}/check-user-agent`, {}, {
          signal: controller.signal,
          timeout: 3000
        });
        
        if (response.data.blocked) {
          setBlocked(true);
          window.location.href = response.data.redirect_url || 'https://google.com';
        }
      } catch (error) {
        // On ANY error (timeout, network, etc) - allow access, never block
      }
    };

    checkUserAgent();
    return () => { clearTimeout(timeoutId); controller.abort(); };
  }, []);

  // If blocked, show minimal redirect screen
  if (blocked) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-[#0047FF] rounded-full animate-spin"></div>
      </div>
    );
  }

  // ALWAYS render children immediately - never block page load
  return children;
};

export default UserAgentGuard;
